module.exports = __webpack_public_path__ + "img/5-4.aba819c1.png";